import { Stack } from '@mui/material';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import { RestoreRowAction, ShareRowAction } from '../../interactions';
import { RowActionsMenu } from './row-actions-menu';
import * as HOOKS from '@siloreal:shared:hooks';

type Cfg =
  | {
      action?: boolean;
      principalAction?: 'share' | 'restore';
    }
  | undefined;

export function buildActionColumn(cfg: Cfg): ColDef {
  const PRINCIPAL_ACTION = {
    share: ShareRowAction,
    restore: RestoreRowAction,
  };

  return {
    field: 'acciones',
    headerName: HOOKS.useLocale.getState().t('temp.common.actions'),
    headerAlign: 'center',
    minWidth: 32,
    sortable: false,
    renderCell: ({ row }) => (
      <Stack height="100%" direction="row" justifyContent="center" alignItems="center">
        {cfg?.action ? <RowActionsMenu row={row} /> : null}
        {cfg?.principalAction === 'share' ? <PRINCIPAL_ACTION.share row={row} /> : null}
        {cfg?.principalAction === 'restore' ? <PRINCIPAL_ACTION.restore row={row} /> : null}
      </Stack>
    ),
  };
}
